import type { JiraProjectOptions } from '@atlassian/jira-relay/src/__generated__/projectJqlBuilderBasicInitQuery.graphql';

export const Filters = {
	myopenissues: Symbol('myopenissues'),
	reportedbyme: Symbol('reportedbyme'),
	allopenissues: Symbol('allopenissues'),
	doneissues: Symbol('doneissues'),
	recentlyviewed: Symbol('recentlyviewed'),
	resolvedrecently: Symbol('resolvedrecently'),
	updatedrecently: Symbol('updatedrecently'),
	allissues: Symbol('allissues'),
} as const;

export const StatusCategoryValues = {
	TO_DO: '"To Do"',
	DONE: '"Done"',
	IN_PROGRESS: '"In Progress"',
} as const;

export const PACKAGE_NAME = 'jiraSoftwareRequestsPage';
export const PACKAGE_TEAM_NAME = 'itops-mithril';
export const PACKAGE_NAME_KEBAB = 'jira-software-requests-page';
export const APP_ID = 'software.requests.requests-page';
export const JSM_PRODUCT_KEY = 'jira-servicedesk.ondemand';

export const PRE_EXPAND_HELP_ARTICLE_ID = '1fKpC0sC49vh7aki1W1IXR';
export const POST_EXPAND_HELP_ARTICLE_ID = '6qkuWXH1exPK3zsq080mUx';
export const READ_SETUP_GUIDE_ARTICLE_ID = '5k7wWhns5pEAqvGaYt6hJt';
export const PROJECT_ADMIN_PERMISSION = 'ADMINISTER_PROJECTS';

export const ERROR_CODE_NOT_FOUND = 404;

export const SERVICE_DESK = 'SERVICE_DESK';
export const PROJECT_FIELD = 'project';
export const SINGLE_SELECT_FIELDS = [PROJECT_FIELD];

// JQL Builder Props
export const JQL_BUILDER_PROJECT_OPTIONS: JiraProjectOptions = {
	projectType: SERVICE_DESK,
};

// Popup placement constants
export const RIGHT_START = 'right-start';
export const LEFT_START = 'left-start';
export const TOP_START = 'top-start';
export const BOTTOM_START = 'bottom-start';

// Instruction keys

export const CONNECT_PROJECT_TO_JSM = 'connect-project-to-jira-service-management';
export const ADD_TEAM_MEMBER = 'add-team-member';
export const PREVIEW_REQUEST_FORM = 'preview-request-form';

// Analytics
export const REQUEST_BUTTON_EVENT = 'goToRequestTypeButton';
export const SERVICE_PROJECT_EVENT = 'goToServiceProjectButton';
export const FEATURE_BUTTON_EVENT = 'goToFeaturesButton';
export const HEADER_DROPDOWN_BUTTON_EVENT = 'headerDropdownClicked';
export const BETTER_TOGETHER_EVENT = 'betterTogether';
export const REQUEST_TAB_RESTRICT_ACCESS_SCREEN = 'requestTabRestrictAccessScreen';
